// src/components/replan/hooks/useComponentSize.js
import { useState, useEffect } from 'react';

export const useComponentSize = (ref) => {
    const [size, setSize] = useState({ width: 0, height: 0 });

    useEffect(() => {
        const updateSize = () => {
            if (ref.current) {
                setSize({
                    width: ref.current.offsetWidth,
                    height: ref.current.offsetHeight,
                });
            }
        };

        let resizeTimeout;
        const debouncedUpdateSize = () => {
            clearTimeout(resizeTimeout);
            resizeTimeout = setTimeout(updateSize, 100);
        };

        window.addEventListener('resize', debouncedUpdateSize);
        updateSize(); // Initial size

        return () => {
            clearTimeout(resizeTimeout);
            window.removeEventListener('resize', debouncedUpdateSize);
        };
    }, [ref]); // Re-run if ref changes (though unlikely for containerRef)

    return size;
};
